import Filter from '@/components/organism/Filter';
import React, { useState } from 'react';
import { textFilters } from './filter';
import { useQuery } from '@tanstack/react-query';
import useQueryValues from '@/hooks/useQueryValues';
import MainContentTitle from '@/components/molecule/MainContentTitle';

export default function FilterTest() {
  const { defaultValues } = useQueryValues({
    test3: ['startOf', 'endOf'],
  });

  const [values, setValues] = useState(defaultValues);

  useQuery({
    queryKey: ['test', values],
    queryFn: () => {
      console.log('values >>>>>', values);

      return 'test';
    },
  });

  return (
    <div>
      <MainContentTitle pageTitle="test" breadcrumbList={['test1', 'test2']} />
      <Filter
        title="필터"
        filters={textFilters}
        onSubmit={values => {
          setValues(values);
        }}
      />
    </div>
  );
}
